import PropTypes from 'prop-types';
import { useComposablePage } from '../helpers/composable';

const ComposableAssetCollection = ({ assets }) => {
  const { render } = useComposablePage();

  return render({ elements: assets }, null, false);
};

ComposableAssetCollection.defaultProps = {
  assets: [],
};

ComposableAssetCollection.propTypes = {
  assets: PropTypes.arrayOf(
    PropTypes.shape({
      __typename: PropTypes.string,
    })
  ),
};

export default ComposableAssetCollection;
